import './App.css';
import Main from './Main.js';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
